<section>
    <div class="flex-detail">
        <section class="card_indicator w-100">
            <h3>Cliente</h3>
            <span>
                <h4 class="mb-0">{{clientDebtorSummary.client.name}}</h4>
                <h5 class="mt-0">{{clientDebtorSummary.client.rut}}</h5>
            </span>
            <h5>
                <br>
            </h5>
            <div class="row">
                <section class="card_indicator col-2 cardWithShadow">
                    <div>
                        <h4 class="kpi-title">Fact Ventas</h4>
                        <h3 class="kpi-value">
                            {{ (clientDebtorSummary?.totalAmountSellInvoices | currency: 'CLP')}}
                            ( {{clientDebtorSummary?.numSellInvoices | number}} )
                        </h3>
                    </div>
                </section>

                <section class="card_indicator col-2 cardWithShadow">
                    <div>
                        <h4 class="kpi-title">NC Ventas</h4>
                        <h3 class="kpi-value">
                            {{clientDebtorSummary?.totalAmountSellCreditNotes | currency: 'CLP'}}
                            ( {{clientDebtorSummary?.numSellCreditNotes}} )
                        </h3>
                    </div>
                </section>
            </div>
        </section>
        <section class="card_indicator w-100">
            <h3>Deudor</h3>
            <span>
                <h4 class="mb-0">{{clientDebtorSummary.debtor.name}}</h4>
                <h5 class="mt-0">{{clientDebtorSummary.debtor.rut}}</h5>
            </span>
            <h5 *ngIf="clientDebtorSummary.debtor.merPubComplaints !== null; else noSpace">Reclamos MP: {{clientDebtorSummary.debtor.merPubComplaints}}</h5>
            <h5 *ngIf="clientDebtorSummary.debtor.merPubComplaints !== null; else noSpace">Ordenes de Compras: {{clientDebtorSummary.debtor.buyOrders}}</h5>
            <h5 *ngIf="clientDebtorSummary.debtor.merPubComplaints !== null; else noSpace">Ratio: {{clientDebtorSummary.debtor.ratio}}%</h5>
            <div class="row">
                <section class="card_indicator col-2 cardWithShadow">
                    <div>
                        <h4 class="kpi-title">Fact Compras</h4>
                        <h3 class="kpi-value">
                            {{ (clientDebtorSummary?.totalAmountBuyInvoices | currency: 'CLP')}}
                            ( {{clientDebtorSummary?.numBuyInvoices | number}} )
                        </h3>
                    </div>
                </section>
        
                <section class="card_indicator col-2 cardWithShadow">
                    <div>
                        <h4 class="kpi-title">NC Compra</h4>
                        <h3 class="kpi-value">
                            {{clientDebtorSummary?.totalAmountBuyCreditNotes | currency: 'CLP'}}
                            ( {{clientDebtorSummary?.numBuyCreditNotes}} )
                        </h3>
                    </div>
                </section>
            </div>
        </section>
    </div>
    <hr>
    <div class="single-row">
        <section class="card_indicator col-1 cardWithShadow">
            <div>
                <h4 class="kpi-title">Primera Fact - Última Fact</h4>
                <h3 class="kpi-value">
                    {{(clientDebtorSummary?.firstInvoiceDate | date: 'dd/MM/yyyy') || 'Sin info'}}
                    -
                    {{(clientDebtorSummary?.lastInvoiceDate | date: 'dd/MM/yyyy') || 'Sin info'}}
                </h3>
            </div>
        </section>

        <section class="card_indicator col-1 cardWithShadow">
            <div>
                <h4 class="kpi-title">Fact Cedidas</h4>
                <h3 class="kpi-value">
                    {{clientDebtorSummary?.totalAmountTransferInvoices | currency: 'CLP'}}
                    ( {{clientDebtorSummary?.numTransferInvoices}} )
                </h3>
            </div>
        </section>
    </div>
    <div class="row pt-1">
        <div #chartDiv class="cardWithShadow overflow single-col" id="chart">
            <apx-chart
              [colors]="chartOptions.colors"
              [series]="chartOptions.series"
              [chart]="chartOptions.chart"
              [xaxis]="chartOptions.xaxis"
              [yaxis]="chartOptions.yaxis"
              [dataLabels]="chartOptions.dataLabels"
              [grid]="chartOptions.grid"
              [stroke]="chartOptions.stroke"
              [title]="chartOptions.title"
              [tooltip]="chartOptions.tooltip"
              [responsive]="chartOptions.responsive"
            ></apx-chart>
        </div>
    </div>
    <div class="pt-1">
        <div class="cardWithShadow">
            <section class="txt-center" *ngIf="dataSource.data.length === 0">
                <h3>Sin Facturas</h3>
            </section>
            <section *ngIf="dataSource.data.length > 0">
                <div class="overflow-table">
                    <table mat-table matSort [dataSource]="dataSource"
                    matSortActive="fechaDocto" matSortDirection="desc">
                        <ng-container 
                        *ngFor="let column of displayColumns"
                        [matColumnDef]="column">
                            <th class="th-header" mat-header-cell mat-sort-header *matHeaderCellDef>
                                {{columnHeaders[column]}}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <ng-container [ngSwitch]="columnTypes[column]">
                                    <h6 *ngSwitchCase="'number'">
                                        {{ element[column] | number }}
                                    </h6>
                                    <h6 *ngSwitchCase="'date'">
                                        {{ (element[column] | date : 'dd-MM-yyyy') || '-' }}
                                    </h6>
                                    <h6 *ngSwitchCase="'currency'">
                                        {{ (element[column] | currency : 'CLP') || '-'}}
                                    </h6>
                                    <i-tabler *ngSwitchCase="'boolean'"
                                    [name]="element[column] ? 'circle-check-filled': 'circle-x-filled'"
                                    [style.color]="element[column] ? 'mediumspringgreen' : 'red'">
                                    </i-tabler>
                                    <h6 *ngSwitchDefault>{{(element[column]) || '-'}}</h6>
                                </ng-container>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>                  
                    </table>
                </div>
                <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
            </section>
        </div>
    </div>
</section>

<ng-template #noSpace>
    <h5>
        <br>
    </h5>
</ng-template>